import { __ } from "@/lib/i18n/functions";

const ArchiveProduct = ({}: TemplateProps) => {
	return (
		<main id="main">
			<h1>Template archive product</h1>
		</main>
	);
};

export default ArchiveProduct;

ArchiveProduct.generateMetadata = async (resolution: Resolution) => {
	return {
		title: __("All our products", resolution.locale),
	};
};
